.toolbar {
  display: grid;
  gap: var(--space-3);
  margin-bottom: var(--space-3);
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.filter {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  height: 2.25rem;
  padding: 0 0.85rem;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-elevated);
  color: var(--color-text-secondary);
  font-size: 0.88rem;
  font-weight: 560;
}

.filter:hover {
  border-color: var(--color-border-strong);
  color: var(--color-text);
}

.filterActive {
  background: var(--color-accent);
  border-color: var(--color-accent);
  color: #f7f6f3;
}

.filterCount {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  opacity: 0.8;
}

.hint {
  margin: 0;
  font-size: 0.88rem;
  color: var(--color-text-muted);
}

.carousel {
  display: grid;
  gap: var(--space-2);
}

.carouselHead {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-3);
}

.arrows,
.detailActions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.arrow,
.close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-bg-elevated);
  color: var(--color-text);
}

.arrow:hover:not(:disabled),
.close:hover {
  border-color: var(--color-border-strong);
  color: var(--color-accent);
}

.arrow:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.arrowIcon,
.closeIcon,
.openIcon,
.linkIcon {
  width: 1.05rem;
  height: 1.05rem;
}

.track {
  position: relative;
  display: flex;
  gap: var(--space-4);
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  padding-bottom: var(--space-2);
  outline: none;
}

.track:focus-visible {
  box-shadow: 0 0 0 2px var(--color-focus);
  border-radius: var(--radius-md);
}

.card {
  flex: 0 0 min(18.5rem, 82%);
  min-width: 0;
  margin: 0;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-bg-elevated);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  opacity: 1;
}

.cardButton {
  display: grid;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
  appearance: none;
  filter: saturate(0.86) brightness(0.8);
  transition: filter 200ms ease;
}

.thumb {
  position: relative;
  margin: 0;
  aspect-ratio: 16 / 10;
  background: var(--color-bg-muted);
  overflow: hidden;
}

.media {
  display: block;
}

.thumb img,
.thumb .media {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}

.thumbDiagram .media {
  object-fit: contain;
}

.thumbFallback {
  display: grid;
  place-items: center;
  height: 100%;
  padding: var(--space-4);
  background: linear-gradient(160deg, var(--color-accent-soft), var(--color-bg-muted));
  color: var(--color-accent);
  font-family: var(--font-display);
  font-size: 1.35rem;
  text-align: center;
}

.badge {
  position: absolute;
  top: 0.7rem;
  left: 0.7rem;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-family: var(--font-mono);
  font-size: 0.68rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: var(--color-bg-elevated);
  color: var(--color-text);
}

.badge_live {
  background: var(--color-accent);
  color: #f7f6f3;
}

.badge_deprecated,
.badge_sunset {
  background: var(--color-danger-soft);
  color: var(--color-text);
}

.badge_internal {
  background: var(--color-highlight-soft);
  color: var(--color-highlight);
}

.cardBody {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-4);
}

.cardBody h3 {
  margin: 0;
  font-size: 1.05rem;
}

.company {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.blurb {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 0.95rem;
  line-height: 1.5;
}

.role {
  margin: 0;
  font-size: 0.8rem;
  color: var(--color-text-muted);
  line-height: 1.4;
}

.result {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 560;
  color: var(--color-accent);
  line-height: 1.4;
}

.fieldBody {
  margin: 0 0 var(--space-2);
}

.note {
  margin: 0;
  font-size: 0.82rem;
  color: var(--color-text-muted);
}

.openHint {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  margin-top: var(--space-1);
  font-size: 0.85rem;
  font-weight: 560;
  color: var(--color-accent);
}

.dialog {
  width: min(52rem, calc(100vw - 1.5rem));
  max-height: calc(100vh - 2rem);
  margin: auto;
  padding: 0;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-bg-elevated);
  color: var(--color-text);
  box-shadow: var(--shadow-md);
  overflow: auto;
}

.dialog::backdrop {
  background: rgb(15 20 19 / 0.55);
}

.detail {
  display: grid;
}

.detailBar {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--color-border);
  background: var(--color-bg-elevated);
}

.detailKicker {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 0.75rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-text-muted);
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 0.75rem;
  align-items: center;
}

.detailIndex {
  color: var(--color-text-secondary);
}

.close {
  background: var(--color-bg-muted);
}

.detailFigure {
  margin: 0;
  border-bottom: 1px solid var(--color-border);
  background: var(--color-bg-muted);
}

.detailFigure img,
.detailFigure .media {
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: center;
}

.detailFigureDiagram {
  display: grid;
  place-items: center;
  padding: var(--space-3) var(--space-4) var(--space-4);
}

.detailFigureDiagram .media {
  aspect-ratio: 16 / 10;
}

.detailFigureArchitecture {
  display: block;
  padding: 0;
}

.detailFigureArchitecture .media {
  aspect-ratio: auto;
  width: 100%;
  height: auto;
}

.detailCopy {
  padding: var(--space-5);
}

.detailCopy h3 {
  margin-bottom: var(--space-3);
  font-size: 1.35rem;
}

.summary {
  margin: 0 0 var(--space-4);
  color: var(--color-text);
  font-size: 1.02rem;
  line-height: 1.6;
}

.fields {
  margin: 0 0 var(--space-4);
  display: grid;
  gap: var(--space-4);
}

.fields dt {
  font-family: var(--font-mono);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-muted);
  margin-bottom: var(--space-1);
}

.fields dd {
  margin: 0;
  color: var(--color-text-secondary);
  line-height: 1.6;
}

.fields ul {
  margin: 0;
}

.links {
  list-style: none;
  margin: var(--space-4) 0 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.links > li {
  margin: 0;
}

.links a {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-weight: 520;
}

.detailNav {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-3);
  margin-top: var(--space-6);
  padding-top: var(--space-4);
  border-top: 1px solid var(--color-border);
}

.detailNavBtn {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-height: 2.75rem;
  padding: 0.5rem 0;
  border: 0;
  background: transparent;
  color: var(--color-accent);
  font-weight: 560;
  text-align: left;
}

.detailNavBtn:last-child {
  justify-content: flex-end;
  text-align: right;
}

@media (hover: hover) and (pointer: fine) {
  .card:hover .cardButton {
    filter: saturate(1) brightness(1);
  }
}

@media (min-width: 700px) {
  .card {
    flex-basis: calc((100% - var(--space-4)) / 2);
  }
}

@media (min-width: 980px) {
  .card {
    flex-basis: calc((100% - (var(--space-4) * 2)) / 3);
  }
}

@media (prefers-reduced-motion: reduce) {
  .cardButton,
  .track {
    transition: none;
    scroll-behavior: auto;
  }

  .track {
    scroll-snap-type: none;
  }
}
